import { createSelector } from '@reduxjs/toolkit';
import { selectLocation } from './selectLocation';
import { normalizeLocation } from 'shared/utils/geo';

export const selectLocationData = createSelector(selectLocation, location => normalizeLocation(location));
